import { useTranslation } from 'react-i18next'
import DashboardTabLayout from '@/components/dashboard/DashboardTabLayout'

export default function BillingHub() {
  const { t } = useTranslation('dashboard')

  return (
    <DashboardTabLayout
      title={t('hubs.billing.title')}
      subtitle={t('hubs.billing.subtitle')}
      tabs={[
        {
          id: 'subscription',
          label: t('hubs.billing.tabs.subscription'),
          to: '/dashboard/billing/subscription',
        },
        {
          id: 'booking-packs',
          label: t('hubs.billing.tabs.bookingPacks'),
          to: '/dashboard/billing/booking-packs',
        },
        {
          id: 'referrals',
          label: t('hubs.billing.tabs.referrals'),
          to: '/dashboard/billing/referrals',
        },
      ]}
    />
  )
}
